import { Link } from 'react-router-dom';
import type { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { MouseEvent, useCallback } from 'react';

import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { IImportRow } from '../interfaces/IImportRow';
import { importDownloadFileByTemplateId } from '../actions/importActions';
import styles from './ImportFileLinkCell.module.scss';

export function ImportFileLinkCell({ row }: ITableRenderCell<IImportRow>) {
  const { filename, id } = row;
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const handleFileLinkClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      filename && dispatch(importDownloadFileByTemplateId({ id, fileName: filename }));
    },
    [dispatch, filename, id],
  );

  return (
    <Link className={styles.FileLink} to="" title={row.filename || undefined} onClick={handleFileLinkClick}>
      {row.filename}
    </Link>
  );
}
